import { render, staticRenderFns } from "./FicaSavingsWidget.vue?vue&type=template&id=72cd967a&scoped=true"
import script from "./FicaSavingsWidget.vue?vue&type=script&lang=ts"
export * from "./FicaSavingsWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd967a",
  null
  
)

export default component.exports